import React from 'react'
import HeroSection from './hero-section/HeroSection'
import Faq from './frequently-ask-questions/Faq'
import { AnimatePresence } from 'framer-motion'

const HomePage = () => {
    return (
        <AnimatePresence>
            <HeroSection />
            <Faq />
        </AnimatePresence>
    )
}

export default HomePage